import { Stack, MenuItem, FormControl, InputLabel, Select, SelectChangeEvent } from '@mui/material';
import { useField, useFormikContext } from 'formik';

type Placement = 'regional' | 'local' | 'federal' | '';

type GeoPickerProps = {
  name: string;
  label: string;
  required?: boolean;
  onPlacementChange?: (placement: string) => void;
};

export const GeoPicker = (props: GeoPickerProps) => {
  const { name, label, onPlacementChange } = props;
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);
  const placement = (field.value || '') as Placement;

  const handlePlacementChange = (event: SelectChangeEvent<Placement>) => {
    const newPlacement = event.target.value as Placement;
    setFieldValue(name, newPlacement);
    
    if (onPlacementChange) {
      onPlacementChange(newPlacement);
    }
  };

  return (
    <Stack spacing={2}>
      <FormControl fullWidth>
        <InputLabel id="placement-label">{label}</InputLabel>
        <Select
          labelId="placement-label"
          value={placement}
          label={label}
          onChange={handlePlacementChange}
        >
          <MenuItem value="">Не выбрано</MenuItem>
          <MenuItem value="federal">Федеральный</MenuItem>
          <MenuItem value="regional">Региональный</MenuItem>
          <MenuItem value="local">Местный</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};
